import { COMMISSIONS_POLICIES_DELETE_INCENTIVE } from '../constants'

export function reducer(state, action) {
  if (action.type === COMMISSIONS_POLICIES_DELETE_INCENTIVE) {
      return {
        ...state,
        policies: {
          ...state.policies,
          incetiveValues: action.data.incetiveValues,
          opportunityIncentiveProduct: action.data.opportunityIncentiveProduct
        },
        commissionPolicy : {
          data : action.data.commissionPolicyDataFiltered
        }
      }
    }
    else {
      return state
    }
}
